export default __webpack_public_path__ + "static/media/oola-bus-login.21d194e7.png";